import { render, staticRenderFns } from "./CustomReportList.vue?vue&type=template&id=724f30aa"
import script from "./CustomReportList.vue?vue&type=script&lang=js"
export * from "./CustomReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports